<template>
  <div class="wg-row">
    <div class="wg-row">
      <div class="wg-row msg-row">
        <!-- Partecipanti  -->
        <div class="com-anm22-app-text-m">
          {{ msg.data.name }}
        </div>
        <div class="time">
          {{ msg.ts | moment('HH:mm') }}
        </div>
      </div>
    </div>
    <div class="wg-row msg-row">
      <div v-html="$anm22.nl2br(msg.data.description)" class="com-anm22-app-text-m"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: Object
  },
  computed: {  },
  created() {
    //console.log(this.msg);
  }
}
</script>

<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.time {
  font-size: 12px;
  margin-left: auto;
}
</style>
